import { IStyleProps } from './Interface'
import { makeStyles } from '@material-ui/core/styles'
import LabelPosition from 'types/LabelPosition'

export default makeStyles<{}, IStyleProps>({
  root: {
    flex: 1,
    flexDirection: ({ labelPosition }) => (labelPosition === LabelPosition.Top ? 'column' : 'row'),
    alignItems: ({ labelPosition }) => (labelPosition === LabelPosition.Top ? 'flex-start' : 'center')
  },
  selectRoot: {
    '&:focus': {
      borderRadius: '40px !important'
    },
    '&:focus ~ .MuiSelect-icon': {
      display: 'inline-block !important'
    }
  },
  select: ({ alwaysEnabled }) => ({
    fontSize: 12,
    minWidth: '180px',
    borderRadius: '40px',
    boxSizing: 'border-box',
    backgroundColor: '#fff',
    height: '35px',
    '& .MuiSelect-selectMenu.Mui-disabled': {
      color: 'black'
    },
    ...(alwaysEnabled
      ? {}
      : {
          '& .MuiOutlinedInput-notchedOutline': {
            border: 'none'
          },
          '&:hover': {
            background: '#EDEBEB'
          },
          '&:not(:hover)': {
            '& .MuiSelect-icon': {
              display: 'none'
            }
          }
        })
  }),
  label: {
    flexShrink: 0,
    fontSize: '10px',
    minWidth: ({ minWidthLabel }) => minWidthLabel,
    marginRight: ({ labelPosition }) => (labelPosition === LabelPosition.Left ? '10px' : '0px'),
    marginBottom: '4px'
  }
})
